import { z } from 'zod';
import { createKeyRecordSchema, createNumericKeyRecordSchema } from '../KeyRecordSchemas.ts';
import { createPartialStrictObjectSchemaWithAtLeastOneProperty } from '../PartialStrictObjectSchema.ts';
import { PlayerColor } from '../PlayerState.ts';
import { validateState } from '../ValidateState.ts';
import { EnumUtils } from '@colonist/utils';
export const MAX_KNIGHT_LEVEL = 3;
const knightLevelSchema = z.union([
    z.literal(1),
    z.literal(2),
    z.literal(3)
]);
const knightStateSchema = z.object({
    owner: z.enum(PlayerColor).exclude([
        'None'
    ]).readonly(),
    level: knightLevelSchema.readonly(),
    isUpgradedThisTurn: z.boolean(),
    isActivated: z.boolean(),
    isActivatedThisTurn: z.boolean(),
    locationCornerIndex: z.union([
        z.number().int().nonnegative(),
        z.null()
    ]).exactOptional()
}).strict();
const knightStatePartialSchema = createPartialStrictObjectSchemaWithAtLeastOneProperty(knightStateSchema);
const knightsSchema = createNumericKeyRecordSchema(knightStateSchema);
const knightsPartialSchema = createNumericKeyRecordSchema(knightStatePartialSchema, {
    requireAtLeastOneEntry: true
});
const knightPlayerStateSchema = z.object({
    maxPurchaseableLevelUnlocked: knightLevelSchema,
    knights: knightsSchema
}).strict();
const playerColorNumericKeys = EnumUtils.getEnumValues(PlayerColor);
export const mechanicKnightStateSchema = createKeyRecordSchema(playerColorNumericKeys, knightPlayerStateSchema);
export function validateMechanicKnightState(data) {
    return validateState(mechanicKnightStateSchema, data);
}
const knightPlayerStatePartialShapeSchema = z.object({
    maxPurchaseableLevelUnlocked: knightLevelSchema,
    knights: knightsPartialSchema
}).strict();
const knightPlayerStatePartialSchema = createPartialStrictObjectSchemaWithAtLeastOneProperty(knightPlayerStatePartialShapeSchema);
export const mechanicKnightStatePartialSchema = createKeyRecordSchema(playerColorNumericKeys, knightPlayerStatePartialSchema, {
    requireAtLeastOneEntry: true
});
